exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/shared-articles.js-WebpackMultiOutput";